// ====== YAHAN SE SAB KUCH CONTROL HOGA ======
// Har card (episode) ki apni alag entry hai:
//   title : card ka naam
//   img   : us episode ki image (URL, ya local: import ep1 from "../assets/ep1.jpg" phir img: ep1)
//   link  : us episode ki FINAL link. Card click -> pehle Mediator page (10s countdown),
//           countdown ke baad "GET LINK" button isi link par le jata hai.
//           Khali "" ho to GET LINK button disabled rehta hai.
//
// Naya episode jodna ho to ek line copy karke id badal do.
// Naya show jodna ho to categories me ek naya object add kar do.
import Epioutnow from "url:./assets/Epioutnow.png"
console.log("IMG:" ,Epioutnow)

export const categories = [
  {
    slug: "bigg-boss",
    title: "Bigg Boss Episode",
    comingSoon: false,
    items: [
      
      { id: 61, title: "Ep 61", img:Epioutnow, link: "https://t.me/+3RvbMEPgq442ODY1",dow:"Download Now",upd:"Latest-Episode" },
      { id: 60, title: "Ep 60", img:Epioutnow, link: "https://t.me/+hNVyUqouMKMwYzBl",dow:"Download Now",upd:"Ystrdy-Episode" },
      { id: 59, title: "Ep 59", img:Epioutnow, link: "https://t.me/+b4mfaXXUOkhlYWY9",dow:"Download Now",},
      { id: 58, title: "Ep 58", img:Epioutnow, link: "https://t.me/+HM-rc4PUfI8xZTVl",dow:"Download Now",},
      { id: 37, title: "Ep 57", img:Epioutnow, link: "https://t.me/+Yv3ptE1MQFdlNWJl",dow:"Download Now", },
      { id: 36, title: "Ep 56", img:Epioutnow, link: "https://t.me/+JOIrRT4cDiQ2NjU9",dow:"Download Now",},
      { id: 35, title: "Ep 55", img:Epioutnow, link: "https://t.me/+0JFIEJn-aFY2M2Vl",dow:"Download Now"},
      { id: 34, title: "Ep 54", img:Epioutnow, link: "https://t.me/+yYOanCnMzHwxYjZl",dow:"Download Now"},
      { id: 33, title: "Ep 53", img:Epioutnow, link: "https://t.me/+rTgbjtCH3YMxOGFl",dow:"Download Now"},
      { id: 32, title: "Ep 52", img:Epioutnow, link: "https://t.me/+qrCkA4JH4300YzJl",dow:"Download Now" },
      { id: 31, title: "Ep 51", img:Epioutnow, link: "https://t.me/+_RZEn4g-lKIzMWVl",dow:"Download Now"},
      { id: 30, title: "Ep 50", img:Epioutnow, link: "https://t.me/+x4yC_u6f6eUyMzM9",dow:"Download Now"},
      { id: 29, title: "Ep 49", img:Epioutnow, link: "https://t.me/+imi3THt8RbI0NTA1",dow:"Download Now" },
      { id: 28, title: "Ep 48", img:Epioutnow, link: "https://t.me/+Lj7NxL2qM9s2ODZl",dow:"Download Now", },
      { id: 27, title: "Ep 47", img:Epioutnow, link: "https://t.me/+QPsBMh_xtbQ0MTFl",dow:"Download Now"},
      { id: 26, title: "Ep 46", img:Epioutnow, link: "https://t.me/+dcFpiTYwJ1hmYTY1",dow:"Download Now"},
      { id: 25, title: "Ep 45", img:Epioutnow, link: "https://t.me/+c6yXqa8DwUE2Yzdl",dow:"Download Now" },
      { id: 24, title: "Ep 44", img:Epioutnow, link: "https://t.me/+LZ1If6-n2g42Yzll",dow:"Download Now"},
      { id: 22, title: "Ep 43", img:Epioutnow, link: "https://t.me/+5Tt0rUpkyuQ4ODk1",dow:"Download Now" },
      { id: 20, title: "Ep 40", img:Epioutnow, link: "https://t.me/+hx8EZIiMGcZmM2I1",dow:"Download Now"},
      { id: 19, title: "Ep 39", img:Epioutnow, link: "https://t.me/+F22y0hqOwF5iNzBl",dow:"Download Now"},
      { id: 18, title: "Ep 38", img:Epioutnow, link: "https://t.me/+lCPqBCUl1y01ZTZl",dow:"Download Now"},
      { id: 17, title: "Ep 37", img:Epioutnow, link: "https://t.me/+mfDrS9zwRvY2MWY1",dow:"Download Now" },
      { id: 16, title: "Ep 36", img:Epioutnow, link: "https://t.me/+v_FK3t-s4IlhNWVl",dow:"Download Now" },
      { id: 15, title: "Ep 35", img:Epioutnow, link: "https://t.me/+XbFHFBtNVRNhMDFl",dow:"Download Now"},
      { id: 14, title: "Ep 34", img:Epioutnow, link: "https://t.me/+plf00S3cBBI5ZmVl",dow:"Download Now"},
      { id: 13, title: "Ep 33", img:Epioutnow, link: "https://t.me/+68f4XmMSnn85OTM9",dow:"Download Now" },
      { id: 12, title: "Ep 32", img:Epioutnow, link: "https://t.me/+iaF3MvCRIrFiZWI9",dow:"Download Now" },
      { id: 11, title: "Ep 31", img:Epioutnow, link: "https://t.me/+ULkCcU7aZjoxNmM1",dow:"Download Now"},
      { id: 10, title: "Ep 30", img: Epioutnow, link: "https://t.me/+Zvi4ctsJD6YwOTQ1",dow:"Download Now"},
      { id: 9, title: "Ep 29", img: Epioutnow, link: "https://t.me/+bCN9ioiXMGw4YTBl",dow:"Download Now" },
      { id: 8, title: "Ep 28", img:Epioutnow, link: "https://t.me/+cqZrj6oinzA1ZmI9",dow:"Download Now" },
      { id: 7, title: "Ep 27", img:Epioutnow, link: "https://t.me/+APkRU4G1IbM3MThl",dow:"Download Now" },
      { id: 6, title: "Ep 26", img:Epioutnow, link: "https://t.me/+cBsJtXWBojJhYWM1",dow:"Download Now" },
      { id: 5, title: "Ep 25", img:Epioutnow, link: "https://t.me/+SEiU9BbabzgxNjRl",dow:"Download Now" },

    ],
  },
  {
    slug: "rise-and-fall",
    title: "Rise & Fall",
    comingSoon: false,
    items: [
      { id: 41, title: "Rise And Fall S02E41..", img:Epioutnow, link:"https://t.me/+nhA2xu-Zh-ZkOGE1",dow:"Download Now",upd:"Latest-Episode" },
      { id: 40, title: "Rise And Fall S02E40..", img:Epioutnow, link:"https://t.me/+oUDJ0fG2hsMzY2Q1",dow:"Download Now",upd:"Ystrdy-Episode" },
      { id: 32, title: "Rise And Fall S02E39..", img:Epioutnow, link:"https://t.me/+UIhgGr_TG7BjMzg1",dow:"Download Now",},
      { id: 31, title: "Rise And Fall S02E38..", img:Epioutnow, link:"https://t.me/+WbI1m32uLZlkY2M1",dow:"Download Now",},
      { id: 30, title: "Rise And Fall S02E37..", img:Epioutnow, link:"https://t.me/+yYo-NpLueHVhMDdl",dow:"Download Now", },
      { id: 29, title: "Rise And Fall S02E36..", img:Epioutnow, link:"https://t.me/+Hf5k8C7Ax4Q5OTQ1",dow:"Download Now"},
      { id: 28, title: "Rise And Fall S02E35..", img:Epioutnow, link:"https://t.me/+w1uOgwdsz9tkM2Y1",dow:"Download Now"},
      { id: 27, title: "Rise And Fall S02E34..", img:Epioutnow, link:"https://t.me/+5RPrvmfCryJmMTRl",dow:"Download Now",},
      { id: 26, title: "Rise And Fall S02E33..", img:Epioutnow, link:"https://t.me/+9xEe2X4Ra7g5MTFl",dow:"Download Now"},
      { id: 25, title: "Rise And Fall S02E32..", img:Epioutnow, link:"https://t.me/+NghUef4U0YphMDU1",dow:"Download Now"},
      { id: 24, title: "Rise And Fall S02E31..", img:Epioutnow, link:"https://t.me/+Ksajzwfd86lmM2M1",dow:"Download Now"},
      { id: 23, title: "Rise And Fall S02E30..", img:Epioutnow, link:"https://t.me/+q_D0wlCLnmozNGU1",dow:"Download Now"},
      { id: 22, title: "Rise And Fall S02E29..", img:Epioutnow, link:"https://t.me/+dW6iF6ujCQY4ODg1",dow:"Download Now"},
      { id: 21, title: "Rise And Fall S02E28..", img:Epioutnow, link:"https://t.me/+4Us-Sn4rtMVmOWVl",dow:"Download Now" },
      { id: 20, title: "Rise And Fall S02E27..", img:Epioutnow, link:"https://t.me/+tEcSq_T1cTVhYzJl",dow:"Download Now" },
      { id: 19, title: "Rise And Fall S02E26..", img:Epioutnow, link:"https://t.me/+RCDfGZiaoOlmMzNl",dow:"Download Now"},
      { id: 18, title: "Rise And Fall S02E25..", img:Epioutnow, link:"https://t.me/+YrvjfQI-JCsyY2Y1",dow:"Download Now"},
      { id: 17, title: "Rise And Fall S02E24..", img:Epioutnow, link:"https://t.me/+D2lftVCZRTI0MTll",dow:"Download Now" },
      { id: 16, title: "Rise And Fall S02E21..", img:Epioutnow, link:"https://t.me/+ncgx7Kq7Lh8wZWQ1",dow:"Download Now" },
      { id: 15, title: "Rise And Fall S02E20..", img:Epioutnow, link:"https://t.me/+kAZuE73-HZFjYjFl",dow:"Download Now" },
      { id: 14, title: "Rise And Fall S02E19..", img:Epioutnow, link:"https://t.me/+5yJbBQSHDy8zNzVl",dow:"Download Now" },
      { id: 13, title: "Rise And Fall S02E18..", img:Epioutnow, link:"https://t.me/+cDXFAvwZ7cxiYmNl",dow:"Download Now"},
      { id: 12, title: "Rise And Fall S02E17 Teen Tigada Kaam Bigada..", img:Epioutnow, link:"https://t.me/+V9EWNUmZkyhiZDhl",dow:"Download Now"},
      { id: 11, title: "Rise.And.Fall.S02E16.Lalu.Aur.Rabriji.Ka.Surprise..", img:Epioutnow, link:"https://t.me/+TZ--ZzxRNf44MjY1",dow:"Download Now"},
      { id: 10, title: "Rise And Fall S02E15 Aukaat Mein Raho..", img:Epioutnow, link: "https://t.me/+ec8SKx0gXR1mZWZl",dow:"Download Now" },
      { id: 9, title: "Rise And Fall S02E14 Kya Aaj Hoga Takhta Palat 720p..", img:Epioutnow, link: "https://t.me/+db1XwwP9XEQ4Y2Jl",dow:"Download Now"},
      { id: 8, title: "Rise.And.Fall.S02E13.Shocking.Eviction.720p..", img:Epioutnow, link: "https://t.me/+upjF5kKq855kNjE1",dow:"Download Now" },
      { id: 7, title: "Rise.And.Fall.S02E12.Kaun.Banega.Ultimate.Ruler..", img:Epioutnow, link: "https://t.me/+EPS9ZGBIrRVjMjll",dow:"Download Now"},
      { id: 6, title: "Rise.And.Fall.S02E11.Lalu.Ji.Dekh.Rahe.Hain..", img:Epioutnow, link: "https://t.me/+RVTo9bg_83wxMThl",dow:"Download Now"},
      { id: 5, title: "Rise.And.Fall.S02E10.Aa.Ab.Maidaan.Mein.", img:Epioutnow, link: "https://t.me/+mlFYnZwJljViNzdl",dow:"Download Now" },
      { id: 4, title: "Rise.And.Fall.S02E09.Teju.Bhaiya.Dulhania.Le.Jayenge.720p.", img: Epioutnow, link: "https://t.me/+d2YFK-e0In9lNmVl",dow:"Download Now" },
      { id: 3, title: "Rise And Fall S02E08 Naagin Vs Nevla 720p MX WEB DL Hind.mp4.720p", img: Epioutnow, link: "https://t.me/+q_p098zbEnA3ZTM9",dow:"Download Now"},
      { id: 2, title: "Rise And Fall S02E07 Do Bhai Dono Tabahi 720p AMZN WEB-DL Hindi.mp4 ", img:Epioutnow, link: "https://t.me/+wsEV4juyHc8yYjA1",dow:"Download Now" },
      { id: 1, title: "Rise.And.Fall.S02E06.Majdoor.Pe.Atyachar.Karenge", img:Epioutnow, link: "https://t.me/+VTfo8N_2TflhZThl",dow:"Download Now" },


    ],
  },
  {
    slug: "india-got-latent",
    title: "India Got Latent",
    comingSoon: false,
    items: [
      { id: 3, title: "Episode MC Stan ", img: Epioutnow, link: "https://t.me/+sd_vXwQOGfw2MTRl",upd:"Latest-Episode" },
      { id: 2, title: "INDIA S GOT LATENT S2 Bonus EP 4 ft. Ayushmann Khurrana, Suhani Shah, Kullu, Rajat Sood 720p.mkv", img:Epioutnow, link: "https://t.me/+uYTQ9eNLxTRlZmQ1",dow:"Download Now",upd:"Old-Episode" },
      
      
    ],
  },


  { 
    slug: "bollywood-film", 
    title: "Bollywood Film", 
    comingSoon: false, 
    items: [
      { id: 1, title: "Drishyam 3", img:"https://image.tmdb.org/t/p/w400/yyWYi1VDg15mk9JlWldmmR7yf9C.jpg", link: "https://t.me/+IeJnI4qRCRw1ZjFl",dow:"Download Now" },


    ] },


  { slug: "hollywood-film",
     title: "Hollywood Film",
      comingSoon: false, 
      items: [
      { id: 2, title: "Moana (2026) BluRay [Hindi (DD5.1) & English] 1080p", img: "https://image.tmdb.org/t/p/w500/zKVgiv5qHCvCLT4A2ymJi5QeXDH.jpg", link: "https://t.me/+XhEkGFk_QwdkN2Nl",dow:"Download Now -1080p" },
      { id: 1, title: "Spider-Man: Brand New Day (2026) WEB-DL [Hindi DD5.1] &[English DD5.1]  Only-1080p| Full Movie", img: "https://image.tmdb.org/t/p/w500/lcU1IHJ3K14HKLpGQnvdlt7tpQQ.jpg", link: "https://hubcloud.ist/drive/okimoammsozqlc1",dow:"Download Now -1080p" },

  ] },



  { slug: "all-film", 
    title: "All Film", 
    comingSoon: false, 
    items: [
      { id: 2, title: "Ranabaali (2026) HQ-HDTC Telugu (LiNE) 1080p 720p & 480p [x264/HEVC] | Full Movie", img:"https://image.tmdb.org/t/p/w500/cXaCyYYbafVyMrs8rwKmxezBYPJ.jpg", link: "https://t.me/+NAIgMkU7xDU4MmE1",dow:"Download Now" },
      { id: 1, title: "The Paradise (2026) DS4K WEB-DL [Hindi (DD5.1) & Telugu] 1080p", img:"https://image.tmdb.org/t/p/w500/smghVMoMWSIFi5dgIz4w1UIcEcY.jpg", link: "https://t.me/+dmXVEyQzy24zNTU9",dow:"Download Now" },

    
  ] },




  { slug: "roadies-episode", 
    title: "Roadies-Episode", 
    comingSoon: false, 
    items: [
      { id: 5, title: "Roadies Rebirth S21E06", img:Epioutnow, link: "https://t.me/+E7C2jSUfMPphNmNl",dow:"Download Now,",upd:"Latest-Episode"},
      { id: 4, title: "Roadies Rebirth S21E05", img:Epioutnow, link: "https://t.me/+4BpqnrhvaQ9lZGU1",dow:"Download Now,",upd:"Old-Episode"},
      { id: 3, title: "Roadies Rebirth S21E04", img:Epioutnow, link: "https://t.me/+BVIgffoJ184zMjQ1",dow:"Download Now,"},
      { id: 2, title: "Roadies Rebirth S21E03", img:Epioutnow, link: "https://t.me/+ErBCOUg3cvU4YmM1",dow:"Download Now,"},
      { id: 1, title: "Roadies Rebirth S21E1&2", img:Epioutnow, link: "https://t.me/+JG56b80tdwFiNWE1",dow:"Download Now,"},

    ] },
];

export const PER_PAGE = 6; // page 2 par ek page me kitne cards
